// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__TS9Rt","container":"styles_container__G1tQT","slideInSearchBar":"styles_slideInSearchBar__4pHt4"};